exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item-container[data-v-3d35c00c] {\n  margin: 0;\n}\n.item[data-v-3d35c00c] {\n  padding: 5px;\n}\n.item-sub[data-v-3d35c00c] {\n  margin: 0 0 0 1rem;\n}\n", ""]);

// exports
